import { useAdminResource, type UseAdminApiResult } from './useAdminApi.js'

/**
 * useScheduledReports
 * --------------------
 * Thin pass-through over `useAdminResource` for the scheduled-reports CRUD
 * resource at `/reports/scheduled-configs`. The backend wraps its GET list
 * in `{ configs: [...] }` (see UI-6a Task 0a), so we set
 * `responseKey: 'configs'`. POST + PATCH return a bare row — handled by
 * `useAdminResource` defaults.
 *
 * Spec: UI-6a Task 7.
 */

/**
 * Frontend mirror of `ScheduledReportConfig` from `packages/db/src/schema/
 * public.ts`. Kept local so the web app doesn't drag in `@kc3/db` (server-
 * only). Field shape must stay in sync with the GET response.
 */
export interface ScheduledReportConfig {
  id: string
  tenantSlug: string
  reportType: string
  recipientEmails: string[]
  format: string
  cronExpression: string
  lookbackDays: number
  enabled: boolean
  createdAt?: string
  updatedAt?: string
}

export type UseScheduledReportsReturn = UseAdminApiResult<ScheduledReportConfig>

export function useScheduledReports(): UseScheduledReportsReturn {
  return useAdminResource<ScheduledReportConfig>('/reports/scheduled-configs', {
    responseKey: 'configs',
  })
}
